:host {
  display: block;
}

:host(.accordion-group-expand-inset) {
  -webkit-margin-start: 16px;
  margin-inline-start: 16px;
  -webkit-margin-end: 16px;
  margin-inline-end: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
}

:host(.accordion-group-expand-inset) ::slotted(ion-accordion) {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

:host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-expanding),
:host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-expanded) {
  margin-left: 0;
  margin-right: 0;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 6px;
}

:host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-previous) {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
:host-context([dir=rtl]):host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-previous), :host-context([dir=rtl]).accordion-group-expand-inset ::slotted(ion-accordion.accordion-previous) {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

@supports selector(:dir(rtl)) {
  :host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-previous):dir(rtl) {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }
}

:host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-next) {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
:host-context([dir=rtl]):host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-next), :host-context([dir=rtl]).accordion-group-expand-inset ::slotted(ion-accordion.accordion-next) {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

@supports selector(:dir(rtl)) {
  :host(.accordion-group-expand-inset) ::slotted(ion-accordion.accordion-next):dir(rtl) {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}

:host(.accordion-group-expand-inset) ::slotted(ion-accordion):first-of-type {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}